module.exports = __webpack_public_path__ + "static/media/minus.ed1b28d9.png";